import { titleCase } from "../../../utils";

type CategoryConfig = {
  label: string;
  color: string;
};

const categoryConfig: Record<string, CategoryConfig> = {
  individual: {
    label: "Individual",
    color: "#1976D2",
  },
  entity: {
    label: "Entity",
    color: "#7B1FA2",
  },
};

const fallbackCategoryConfig: CategoryConfig = {
  label: "Unknown",
  color: "#6D7580",
};

const normalizeCategory = (category: string = "") => category.trim().toLowerCase();

export const getCategoryLabel = (category: string = ""): string => {
  const normalizedCategory = normalizeCategory(category);
  const configuredCategory = categoryConfig[normalizedCategory];
  if (configuredCategory) {
    return configuredCategory.label;
  }
  if (!normalizedCategory) {
    return fallbackCategoryConfig.label;
  }
  return titleCase(normalizedCategory);
};

export const getCategoryColor = (category: string = ""): string => {
  const normalizedCategory = normalizeCategory(category);
  return (
    categoryConfig[normalizedCategory]?.color ?? fallbackCategoryConfig.color
  );
};
